import api from './api';

// Kapı / kapı grubu erişim kapsamı. scopeUrl örn. `/v1/gates/{id}/scope`.
export const getAccessScope = (scopeUrl) => api.get(scopeUrl);
export const saveAccessScope = (scopeUrl, data) => api.put(scopeUrl, data);
